var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-common-form-approval-default"},[(_vm.hasData)?[_c('pre',{staticClass:"view-data-content"},[_vm._v(_vm._s(_vm.formattedData))])]:[_c('div',{staticClass:"view-data-empty"},[_c('Hint',{attrs:{"type":"empty"}},[_c('div',[_vm._v("暂无审批数据")])])],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }